/**
 * Map nearby pill helpers — the count copy, and the gate that decides whether
 * a count may be shown at all.
 *
 * There is no radar motion here any more. `NearbyCollectorsStatus` retired the
 * pulse deliberately (a ring that idles forever implies the map is still
 * working when it has already finished), so the class name and the duration
 * helper that fed it went with it, along with their global CSS.
 */
import { DISCOVERY_OK } from "../layout/components/firstTradeMission";

export function nearbyCollectorsLabel(count) {
  const n = Number(count) || 0;
  if (n <= 0) return "No collectors nearby yet";
  return `${n} collector${n === 1 ? "" : "s"} nearby`;
}

/**
 * The pill is a factual claim about the neighbourhood, so it only renders when
 * we actually know something.
 *
 * A failed or rate-limited discovery request tells you nothing about who is
 * nearby — it tells you about the request. Rendering a count in that state
 * either shows 0 (a lie: "nobody is here") or a stale count from a previous
 * position (a different lie: "these people are here now"). Both are worse than
 * silence, so the pill is withheld entirely and the empty-state copy explains
 * the real cause instead (see `emptyMapReason`).
 *
 * `discoveryStatus` defaults to DISCOVERY_OK so callers that never load
 * discovery status keep their previous behaviour.
 */
export function shouldShowNearbyPill({
  viewMode,
  locationLoading,
  count,
  discoveryStatus = DISCOVERY_OK,
}) {
  return (
    viewMode === "map" &&
    !locationLoading &&
    discoveryStatus === DISCOVERY_OK &&
    (Number(count) || 0) > 0
  );
}

